<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <v-btn color="white" @click="$router.push({ name: 'website.apps' })">
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Back
      </v-btn>
      <v-btn color="primary" @click="$router.push({ name: 'website.apps-migrate.create' })">
        Create a store migrate
      </v-btn>
    </div>
    <h1 class="text-center">List store migrate to Dr</h1>
    <v-skeleton-loader v-if="isLoading" type="table"></v-skeleton-loader>
    <template v-else>
      <v-card v-if="document && document.length > 0" class="pa-3">
        <Resource
          :document="document"
          :updateRouterCallback="updateRouterCallback"
          :filter-fields="null"
          :callbackAction="callbackAction"
          :columns="columns"
        />
        <!-- <v-col cols="12" class="d-flex justify-space-between">
            <limit-page :callback="setLimit" :page.sync="page" />
            <pagination :length="1000000000000" :visible="0" :page.sync="page"></pagination>
          </v-col> -->
      </v-card>
      <div class="d-flex justify-center" v-else>
        <div class="col-7">
          <div class="d-flex justify-center">
            <v-img
              max-height="192px"
              max-width="192px"
              :src="`https://admin-cdn.shopbase.com/2f64a69867/img/private-apps-thumb-placeholder.1ffa129a.svg`"
            />
          </div>
          <div class="text-center py-6">
            Private apps can streamline store processes like accounting, importing products,or even create unique
            customer-facing storefronts.
          </div>
          <div class="d-flex justify-center">
            <v-btn color="primary py-5" @click="$router.push({ name: 'website.apps-migrate.create' })">
              <span class="white--text">Migrate to Dropnoxe</span>
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import MenuApps from '../components/MenuApps';
import Resource from '@/components/Resources';
import resourceListMixin from '@/mixins/resource-list';
import { migrateApi } from '@/apis/migrate';
export default {
  components: {
    // MenuApps,
    Resource,
  },
  // mixins: [resourceListMixin],
  data() {
    return {
      menu: [],
      dialog: false,
      isLoading: false,
      defaultActiveMenu: '',
      document: [],
      appDel: {},
      columns: {
        // Selectable: {
        //   blankLabel: true,
        //   kind: 'selectable',
        //   width: 1,
        // },
        'URL store': {
          field: 'sourceStoreUrl',
          kind: 'title',
        },
        'Api key': {
          // blankLabel: true,
          field: 'sourceStoreApiKey',
          kind: 'title',
        },
        'Store Type': {
          field: 'sourceStoreType',
          kind: 'title',
        },
        Status: {
          field: 'status',
          kind: 'migrate-status',
        },
        Actions: {
          kind: 'action',
          listAction: [
            // {
            //   name: 'relaunch',
            // },
            // {
            //   name: 'delete',
            // },
          ],
        },
      },
      page: 1,
      limit: 50,
    };
  },
  methods: {
    callbackAction(action, ids) {
      if (action.action === 'delete') {
        this.appDel = this.document.find(app => app._id === ids);
        this.dialog = true;
      }
    },
    async deleteApp() {
      try {
        await migrateApi.deletePrivateApp(this.appDel._id);
        this.$store.commit('setMessages', {
          messages: 'Delete app successfully!',
          type: 'success',
        });
        this.isLoading = true;
        let params = {
          page: 0,
          limit: 50,
        };
        let data = await migrateApi.get(params);
        this.document = data.data.privateApps;
        this.isLoading = false;
      } catch (error) {
        this.$store.commit('setMessages', {
          messages: 'Error',
          type: 'error',
        });
      }
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    },
    updateRouterCallback(id) {
      this.$router.push({ name: 'website.apps-migrate.edit', params: { id: id } });
    },
    setLimit(limit) {
      this.limit = limit;
    },
  },
  watch: {},
  async created() {
    this.isLoading = true;
    let params = {
      page: 1,
      limit: 100,
    };
    let data = await migrateApi.get(params);
    this.document = data.data.storeDataTransfers;
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.upsell-page {
  height: 100% !important;
  .upsell-page-container {
    @include flex(center, flex-center);
    overflow-y: auto;
    padding-left: 260px;
    & .upsell-page-content {
      max-width: 1280px;
      min-width: 700px;
      margin-top: 40px;
    }
  }
}
</style>
